import { Injectable } from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {AllEventsSetting} from '../models/all-events-setting';
import {BackendService} from './backend.service';
import {HttpHeaders} from '@angular/common/http';

@Injectable()
export class UserService {

  constructor(private http: BackendService) { }

  getAllUsers(): Observable<any> {
    return Observable.create(observe => {
      this.http.get(`/api/data/user/getAllUsers`)
        .subscribe((res) => {
          const obj = Object.assign(new AllEventsSetting(), res);
          observe.next(obj.data);
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  postAddUser(user: any): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/addUser`, JSON.stringify(user))
        .subscribe((res) => {
          observe.next(Object.assign(new AllEventsSetting(), res));
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  deleteUser(userId: number): Observable<any> {
    return Observable.create(observe => {
      this.http.delete(`/api/data/user/deleteUser/${userId}`).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  setRole(userId: number): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/setRole/${userId}`, JSON.stringify({userId: userId})).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  setAuthority(user): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/setAuthority`, JSON.stringify(user)).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  removeAuthority(user): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/removeAuthority`, JSON.stringify(user)).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  restoreUser(userId: number, model: any): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/restorePassword/${userId}`, JSON.stringify(model)).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  updateUser(userId: number, model: any): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/updateUser/${userId}`, JSON.stringify(model)).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  changePassword(model: any): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/changePassword`, JSON.stringify(model)).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  getBookCount(): Observable<any> {
    return Observable.create(observe => {
      this.http.get(`/api/data/user/getBookCount`).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  updateAvatar(userId: number, formData: any): Observable<any> {
    return Observable.create(observe => {
      let httpHeaders = new HttpHeaders();
      httpHeaders = httpHeaders.set('Accept', 'application/json');
      httpHeaders = httpHeaders.set('Access-Control-Allow-Origin', '*');
      this.http.post(`/api/data/user/changeAvatar/${userId}`, formData, {headers: httpHeaders})
        .subscribe((res) => {
          observe.next(Object.assign(new AllEventsSetting(), res));
          observe.complete();
        }, error => {
          observe.error(error);
        });
    });
  }

  settingSiteUser(model: any): Observable<any> {
    return Observable.create(observe => {
      this.http.post(`/api/data/user/setting-site-user`, JSON.stringify(model)).subscribe((res) => {
        observe.next(Object.assign(new AllEventsSetting(), res));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }

  getSiteUser(): Observable<any> {
    return Observable.create(observe => {
      this.http.get(`/api/data/user/get-site-user`).subscribe((res) => {
        const obj = Object.assign(new AllEventsSetting(), res);
        observe.next(Object.assign(new AllEventsSetting(), obj.data));
        observe.complete();
      }, error => {
        observe.error(error);
      });
    });
  }
}




// WEBPACK FOOTER //
// /app/src/app/services/user.service.ts